export function createVoiceAttemptAuthority(initiallyActive = true) {
  let generation = 0
  let active = Boolean(initiallyActive)
  let mounted = true

  return {
    begin() {
      generation += 1
      return generation
    },
    invalidate() {
      generation += 1
    },
    setActive(nextActive) {
      const next = Boolean(nextActive)
      if (active && !next) generation += 1
      active = next
    },
    unmount() {
      mounted = false
      generation += 1
    },
    isCurrent(attempt) {
      return mounted && active && attempt === generation
    },
    isActive() {
      return mounted && active
    },
  }
}
